import React, { useEffect, useState } from 'react';
import Header from '../components/Header';
import Hero from '../components/Hero';
import AvailableRooms from '../components/AvailableRooms';
import About from '../components/About';
import WeatherWidget from '../components/WeatherWidget';
import Facilities from '../components/Facilities';
import Gallery from '../components/Gallery';
import BookingForm from '../components/BookingForm';
import Testimonials from '../components/Testimonials';
import Contact from '../components/Contact';
import Footer from '../components/Footer';
import { useLocation } from 'react-router-dom';

const HomePage = () => {
  const location = useLocation();
  const [activeSection, setActiveSection] = useState('home');
  const [showAvailableRooms, setShowAvailableRooms] = useState(false);
  const [checkIn, setCheckIn] = useState(null);
  const [checkOut, setCheckOut] = useState(null);
  const [adults, setAdults] = useState('2');
  const [kids, setKids] = useState('0');
  const [prefilledRoomType, setPrefilledRoomType] = useState('');

  const handleCheckAvailability = () => {
    setShowAvailableRooms(true);
    // Scroll to available rooms section
    setTimeout(() => {
      const element = document.querySelector('.available-rooms-section');
      if (element) {
        element.scrollIntoView({ behavior: 'smooth' });
      }
    }, 100);
  };

  const handleBookNow = (roomType = '') => {
    setPrefilledRoomType(roomType);
  };

  useEffect(() => {
    if (location.pathname === "/") {
      const el = document.getElementById("home");
      if (el) {
        el.scrollIntoView({ behavior: "smooth" });
      }
    } else if (location.pathname === "/about") {
      const el = document.getElementById("about");
      if (el) {
        el.scrollIntoView({ behavior: "smooth" });
      }
    } else if (location.pathname === "/rooms") {
      const el = document.getElementById("facilities");
      if (el) {
        el.scrollIntoView({ behavior: "smooth" });
      }
    } else if (location.pathname === "/gallery") {
      const el = document.getElementById("gallery");
      if (el) {
        el.scrollIntoView({ behavior: "smooth" });
      }
    } else if (location.pathname === "/booking") {
      const el = document.getElementById("booking");
      if (el) {
        el.scrollIntoView({ behavior: "smooth" });
      }
    } else if (location.pathname === "/contact") {
      const el = document.getElementById("contact");
      if (el) {
        el.scrollIntoView({ behavior: "smooth" });
      }
    }
  }, [location.pathname]);

  return (
    <div className="homepage">
      <Header activeSection={activeSection} setActiveSection={setActiveSection} />
      <Hero id="home"
        onCheckAvailability={handleCheckAvailability}
        checkIn={checkIn}
        setCheckIn={setCheckIn}
        checkOut={checkOut}
        setCheckOut={setCheckOut}
        adults={adults}
        setAdults={setAdults}
        kids={kids}
        setKids={setKids}
      />
      {showAvailableRooms && (
        <div>
          <AvailableRooms 
            checkIn={checkIn}
            checkOut={checkOut}
            adults={adults}
            kids={kids}
            onClose={() => setShowAvailableRooms(false)}
            onBookNow={handleBookNow}
          />
        </div>
      )}
      <About id="about" />
      <WeatherWidget />
      <Facilities id="facilities" />
      <Gallery id="gallery" />
      {/* <Testimonials /> */}
      <BookingForm id="booking"
        prefilledCheckIn={checkIn}
        prefilledCheckOut={checkOut}
        prefilledGuests={adults}
        prefilledRoomType={prefilledRoomType}
      />
      <Contact id="contact" />
      <Footer />
    </div>
  );
};

export default HomePage;
